import { render, staticRenderFns } from "./content-placeholder.vue?vue&type=template&id=5346f52c&"
import script from "./content-placeholder.vue?vue&type=script&lang=js&"
export * from "./content-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./content-placeholder.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-placeholder.vue"
export default component.exports